import { AnyAction } from 'redux';

import { carsActions } from '../reducer';

export const resetSelectedCar = (): AnyAction => carsActions.resetSelectedCar();
